//Driver Performance Reducers
import driverPerformanceEventsTabRedux from '../../views/events/redux/slice'
import driverPerformanceEventsTabAdvancedFiltersRedux from '../../views/events/modals/advancedFilters/redux/slice';
import driverPerformanceEventsTabEditEventRedux from '../../views/events/modals/editEvent/redux/slice';
import driverPerformanceEventsTabDriverInfoRedux from '../../views/events/modals/driverInfo/redux/slice';
import driverPerformanceEventsTabAssetInfoRedux from '../../views/events/modals/assetInfo/redux/slice';
import driverPerformanceCasesTabAdvancedFiltersRedux from '../../views/cases/modals/advancedFilters/redux/slice';
import driverPerformanceCasesTabEditCoachRedux from '../../views/cases/modals/editCoachPanel/redux/slice';
import driverPerformanceCasesTabCreatePanelRedux from '../../views/cases/modals/createPanel/redux/slice';
import driverPerformanceCasesTabViewCreationPanelRedux from '../../views/cases/modals/viewCreationPanel/redux/slice';
import driverPerformanceCasesTabRedux from '../../views/cases/redux/slice'
import driverPerformanceDashboardRedux from '../../views/dashboard/redux/slice';
import driverPerformanceDashboardTabAdvancedFiltersRedux from '../../views/dashboard/components/advancedFilters/redux/slice';
import dashboardRedux from '../../components/dashboard/redux/slice';
import driverPerformanceMainRedux from '../../views/main/redux/slice';
import driverPerformanceEventsTabEventInfoRedux from '../../views/events/modals/eventInfo/redux/slice';
import dashboardDriverPerformanceSliceRedux from '../../views/driver/redux/slice';
import driverPerformanceDriverTabAdvancedFiltersRedux from '../../views/driver/modals/advancedFilters/redux/slice';
import driverPerformanceCaseDetailRedux from '../../views/caseDetail/redux/slice';
import driverPerformanceOverviewTabRedux from '../../views/overviewTab/redux/slice';
import driverPerformanceDriverViewRouteRedux from '../../views/driverDetail/redux/slice';
import driverPerformanceImprovementPlanTabRedux from '../../views/implovementPlanTab/redux/slice';
import driverPerformanceRiskTabRedux from '../../views/riskTab/redux/slice';
import driverPerformanceOverviewRedux from '../../views/overviewTabDriver/redux/slice';
import driverPerformanceEventsTabCaseInfoRedux from '../../views/events/modals/caseInfo/redux/slice';
import driverPerformanceDriverTabCreateDriverCoachingRedux from '../../views/driver/modals/createDriverCoaching/redux/slice';
import driverPerformanceDriverTabShareDriverRedux from '../../views/driver/modals/shareDriver/redux/slice';
import driverPerformanceEventsTabAssignDriverSliceRedux from '../../views/events/modals/assingDriver/redux/slice';
import driverPerformanceEventsTabAssignStatusSliceRedux from '../../views/events/modals/assingStatus/redux/slice';
import driverPerformanceFunctionTabRedux from '../../views/functionTab/redux/slice';
import driverPerformanceRiskEventsTabRedux from '../../views/riskEventsTab/redux/slice';
import coachingEducationRedux from '../../views/functionTab/widgets/coachingEducation/redux/slice';
import performanceImprovementRedux from '../../views/functionTab/widgets/performanceImprovement/redux/slice';
import interventionRedux from '../../views/functionTab/widgets/intervention/redux/slice';
import escalationRedux from '../../views/functionTab/widgets/escalation/redux/slice';


export default {
  driverPerformanceEventsTabRedux,
  driverPerformanceEventsTabAdvancedFiltersRedux,
  driverPerformanceEventsTabEditEventRedux,
  driverPerformanceEventsTabDriverInfoRedux,
  driverPerformanceEventsTabAssetInfoRedux,
  driverPerformanceCasesTabRedux,
  driverPerformanceCasesTabAdvancedFiltersRedux,
  driverPerformanceCasesTabCreatePanelRedux,
  driverPerformanceCasesTabViewCreationPanelRedux,
  driverPerformanceCasesTabEditCoachRedux,
  driverPerformanceDashboardRedux,
  dashboardDriverPerformanceSliceRedux,
  driverPerformanceDashboardTabAdvancedFiltersRedux,
  dashboardRedux,
  driverPerformanceMainRedux,
  driverPerformanceEventsTabEventInfoRedux,
  driverPerformanceDriverTabAdvancedFiltersRedux,
  driverPerformanceCaseDetailRedux,
  driverPerformanceOverviewTabRedux,
  driverPerformanceDriverViewRouteRedux,
  driverPerformanceImprovementPlanTabRedux,
  driverPerformanceRiskTabRedux,
  driverPerformanceOverviewRedux,
  driverPerformanceEventsTabCaseInfoRedux,
  driverPerformanceDriverTabCreateDriverCoachingRedux,
  driverPerformanceDriverTabShareDriverRedux,
  driverPerformanceEventsTabAssignDriverSliceRedux,
  driverPerformanceEventsTabAssignStatusSliceRedux,
  driverPerformanceFunctionTabRedux,
  driverPerformanceRiskEventsTabRedux,
  coachingEducationRedux,
  performanceImprovementRedux,
  interventionRedux,
  escalationRedux
};
